export const PENDING = 'PENDING';
export const SUCCESS = 'SUCCESS';
export const FAILED = 'FAILED';
export const UNCLAIMED = 'UNCLAIMED';
export const RETURNED = 'RETURNED';
export const ONHOLD = 'ONHOLD';
export const BLOCKED = 'BLOCKED';
export const REFUNDED = 'REFUNDED';
export const REVERSED = 'REVERSED';
